<template>
  <div class="page-container-wide">
    <div class="blog-header">
      <h1 class="page-title">{{ $t('blog') }}</h1>
      <div class="search-bar" :class="{ active: searchActive }">
        <input
          ref="searchInput"
          v-model="searchQuery"
          class="search-input"
          :placeholder="$t('search') || '搜索...'"
          @input="onSearch"
          @blur="onSearchBlur"
        />
        <button class="search-btn" @click="toggleSearch">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
        </button>
      </div>
    </div>

    <div v-if="loading" class="loading-state text-tertiary">Loading...</div>

    <div v-else-if="filteredPosts.length === 0" class="empty-state">
      <p class="text-tertiary">{{ searchQuery ? '无匹配结果' : $t('no_posts') }}</p>
    </div>

    <div v-else class="blog-list">
      <router-link
        v-for="post in filteredPosts"
        :key="post.id"
        :to="'/blog/' + post.id"
        class="blog-card"
      >
        <h2 class="blog-card-title">{{ post.title }}</h2>
        <div class="blog-card-meta">
          <span class="text-tertiary text-xs">{{ formatDate(post.created_at) }}</span>
        </div>
      </router-link>
    </div>

    <div v-if="!searchQuery && totalPages > 1" class="pagination mt-4">
      <button class="btn btn-sm" :disabled="page <= 1" @click="changePage(page - 1)">&larr;</button>
      <span class="text-sm text-secondary">{{ page }} / {{ totalPages }}</span>
      <button class="btn btn-sm" :disabled="page >= totalPages" @click="changePage(page + 1)">&rarr;</button>
    </div>
  </div>
</template>

<script>
import { getPosts } from '../api'

export default {
  name: 'Blog',
  data() {
    return {
      posts: [],
      loading: true,
      page: 1,
      limit: 50,
      total: 0,
      totalPages: 0,
      searchQuery: '',
      searchActive: false,
      allPosts: []
    }
  },
  computed: {
    filteredPosts() {
      if (!this.searchQuery) return this.posts
      const q = this.searchQuery.toLowerCase()
      return this.posts.filter(p => p.title.toLowerCase().includes(q))
    }
  },
  methods: {
    formatDate(d) {
      if (!d) return ''
      const date = new Date(d)
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
    },
    fetchPosts() {
      this.loading = true
      getPosts(this.page, this.limit).then(res => {
        const d = res.data.data
        this.posts = d.posts || []
        this.total = d.total
        this.totalPages = d.total_pages
      }).catch(() => { this.posts = [] }).finally(() => { this.loading = false })
    },
    changePage(p) { this.page = p; this.fetchPosts(); window.scrollTo({ top: 0, behavior: 'smooth' }) },
    toggleSearch() {
      this.searchActive = !this.searchActive
      if (this.searchActive) {
        this.$nextTick(() => this.$refs.searchInput.focus())
      } else {
        this.searchQuery = ''
      }
    },
    onSearch() {},
    onSearchBlur() {
      if (!this.searchQuery) this.searchActive = false
    }
  },
  mounted() { this.fetchPosts() }
}
</script>

<style scoped>
.blog-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 28px; }
.page-title { font-size: 1.3rem; font-weight: 600; }
.search-bar { display: flex; align-items: center; }
.search-input {
  width: 0; padding: 0; border: none; outline: none;
  background: transparent; color: var(--text-primary);
  font-size: 0.85rem; font-family: inherit;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.search-bar.active .search-input {
  width: 160px; padding: 4px 8px;
}
.search-btn {
  width: 32px; height: 32px; border-radius: 50%;
  border: none; background: transparent; color: var(--text-tertiary);
  cursor: pointer; display: flex; align-items: center; justify-content: center;
  transition: all 0.2s ease; flex-shrink: 0;
}
.search-bar.active .search-btn { border: 1px solid var(--border-color); color: var(--text-primary); }
.search-btn:hover { color: var(--text-primary); }
.blog-list { display: flex; flex-direction: column; }
.blog-card { display: block; padding: 20px 0; border-bottom: 1px solid var(--border-light); transition: padding 0.2s cubic-bezier(0.4, 0, 0.2, 1); }
.blog-card:hover { padding-left: 8px; }
.blog-card-title { font-size: 1.05rem; font-weight: 500; margin-bottom: 6px; }
.blog-card-meta { display: flex; align-items: center; gap: 12px; }
.pagination { display: flex; align-items: center; justify-content: center; gap: 16px; }
.loading-state, .empty-state { padding: 48px 0; text-align: center; }
</style>
